export { default } from './EmployeeEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeEdit/index.js